import React from "react";
import { formatStaffDepartmentLabel } from "../../utils/scheduleHelpers";
import "../../styles/scheduleTable.css";

/** Admin directory — staff name + role badge (Office, Admin, etc.). */
export default function CreatedByCell({ row }) {
  const name = String(row?.created_by_name ?? "").trim();
  const dept = formatStaffDepartmentLabel({
    role_name: row?.created_by_role_name,
    role_slug: row?.created_by_role_slug,
  });

  if (!name && !dept) {
    return <span className="schedule-created-by">—</span>;
  }

  return (
    <span className="schedule-created-by">
      {name ? <span className="schedule-created-by__name">{name}</span> : null}
      {dept ? <span className="schedule-created-by__dept">{dept}</span> : null}
    </span>
  );
}
